import {IPrimaryKey} from "../interfaces/iprimary-key";
import {Cid10Model} from "./cid10.model";

export class AtestadoModelPrimaryKey implements IPrimaryKey<AtestadoModel> {
  seq: number = 0;

  get id(): string {
    return `${this.seq}`;
  }
}

export class AtestadoModel extends AtestadoModelPrimaryKey {
  numero_Guia: number = 0;
  data_Dispensa: Date = new Date();
  nome_Encaminhamento?: string;
  dias_Dispensa?: number;
  ind_Tipo?: string = 'A1';
  seq_Cid?: number;
  motivo_Declaracao?: string;
  hora_Inicial_Atd?: string;
  hora_Final_Atd?: string;

  cid10?: Cid10Model;
}
